'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('react');
require('prop-types');
require('./Button.js');
require('./FontIcon.js');
require('./Typography-d8cec00c.js');
var Modal = require('./Modal-71e14f2d.js');
require('react/jsx-runtime');
require('@babel/runtime/helpers/defineProperty');
require('@babel/runtime/helpers/slicedToArray');
require('./DualIcon.js');
require('react-svg');
require('@linaria/react');
require('./Loader.js');
require('./Link.js');
require('deepmerge');



exports["default"] = Modal.Modal;
